module.exports = __webpack_public_path__ + "img/cover-minigame-bg.2b327e6d.jpg";